import { buildAPIUrl, responseInterceptor, toQueryString } from './index';

export interface GlobalDataReportModel {
  reportId: number;
  title: string;
  description: string;
  publishedDate: string;
  stylusDirectories: string;
  stylusPillarsofInnovation: string;
  reportPdfFileName: string;
  loading?: boolean;
}

export interface GlobalDataReportsResponse {
  list: GlobalDataReportModel[];
  totalRecords: number;
  page: number;
  pageSize: number;
}

export const getGlobalDataReports = async (params: {
  searchTerm?: string;
  directory?: string;
  innoPlat?: string;
  year?: string;
  page?: number;
  pageSize?: number;
}): Promise<GlobalDataReportsResponse> => {
  const apiUrl = await buildAPIUrl();
  const queryString = toQueryString(params);
  const url = `${apiUrl}/umbraco/Api/GlobalDataReport/GetReportListing${queryString}`;

  return fetch(url, {
    method: 'GET',
    credentials: 'include',
  })
    .then((response) => responseInterceptor(response))
    .then((response) => response.json());
};

export const getGlobalDataPdf = async (fileName: string): Promise<Blob> => {
  const apiUrl = typeof window !== 'undefined' ? '/apipipe' : await buildAPIUrl();
  const url = `${apiUrl}/umbraco/Api/GlobalDataReport/GetPdf?apiQueryParams=${encodeURIComponent(fileName)}`;

  return fetch(url, {
    method: 'GET',
    credentials: 'include',
  })
    .then((response) => responseInterceptor(response))
    .then((response) => response.blob());
};
